var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app"},[_c('header-component'),_c('div',{staticClass:"app__content"},[_c('router-view')],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }